import { createContext, useContext, useMemo } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
  const client = useQueryClient();
  const me = useQuery({
    queryKey: ["admin", "me"],
    queryFn: async () => (await api.get("/admin/auth/me")).data,
    retry: false,
    staleTime: 30_000,
  });
  const value = useMemo(() => ({
    me: me.data,
    isAuthenticated: !!me.data && !me.error,
    isLoading: me.isLoading,
    isPending: me.error?.response?.status === 401 && me.error?.response?.data?.detail?.includes("second step"),
    refetch: me.refetch,
    can: (perm) => !!me.data?.permissions?.includes(perm),
    invalidate: () => client.invalidateQueries({ queryKey: ["admin"] }),
  }), [me.data, me.error, me.isLoading, me.refetch, client]);
  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
}

export function useAdmin() {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error("useAdmin must be used inside AdminProvider");
  return ctx;
}
